import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Wrapper } from "modules/theme";
import SettingsSidebar from "../../sidebar";
import { Alert, confirm } from "modules/theme";
import { CenterFlexRow, BackButton } from "../../styles";
import { Dropdown, MenuItem } from "react-bootstrap";
import { HiDotsVertical } from "react-icons/hi";
import APIManager from "modules/common/apiManager";
import EmailtempleteAddEdit from "./EmailtempleteAddEdit";
import { Row, RowTitle, Box, BoxName, Divider } from "../../main/styles";
import { BarItems } from "modules/theme";
import { Modal } from "react-bootstrap";
import { FiInfo, FiTrash2 } from "react-icons/fi";
import { PerPage } from "helpers/system-config";
import { FormWrapper, FormColumn } from "modules/theme";
import { ModalFooter } from "modules/theme";
import {
  ModalTrigger,
  Pagination,
  Button,
  FormControl,
  ActionButtons,
  Table,
  Label,
  Tip,
  DataWithLoader,
  FormGroup,
  ControlLabel,
  ReportPagination,
  SeachForm,
  ImportFile,
  DropdownToggle,
  DataWrapperClass,
  ButtonCommonTheme,
  Icon,
  SettingDropdownMenu,
} from "modules/theme";
import { leftSidebarType, modalType } from "../../../../../helpers/dotenv";
import { MdOutlineAdd } from "react-icons/md";
import { OverflowClass } from "modules/theme";
import { CustomDropdown } from "modules/common/components";

export class EmailTemplete extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.moduleName = `Email Template`;
    // this.handleModalShowHide = this.handleModalShowHide.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModalShow = this.closeModalShow.bind(this);
    // this.openModalShow = this.openModalShow.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.clearSearchField = this.clearSearchField.bind(this);
    this.state = {
      listData: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      loading: false,
      editData: null,
      showHide: false,
      modalType: modalType,
      search: "",
      MasterChecked: false,
      SelectedList: [],
      ary: [],
      show: false,
    };
  }

  handleModal() {
    this.setState({ show: !this.state.show });
  }

  onMasterCheck(e) {
    let tempList = this.state.listData;
    // Check/ UnCheck All Items
    tempList.map((listData) => (listData.selected = e.target.checked));
    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  clearSearchField() {
    this.setState({ searchValue: "" });
  }

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map((user) => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });
    //To Control Master Checkbox State
    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter((e) => e.selected).length;
    // Update State
    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  deleteAllData(e) {
    let _this = this;
    e.preventDefault();
    // const ary = [];
    const list = this.state.SelectedList.map((data) => {
      // ary = data._id;
      this.state.ary.push(data._id);
      // this.setState({ ary: data._id });
    });
    this.mAPI.sendPostAPI(
      `setting/email-templete/multiple/usingIds`,
      {
        ids: this.state.ary,
      },
      (data) => {
        _this.setState({
          SelectedList: [],
          MasterChecked: false,
          currentPage: 1,
        });
        this.getEmailProvider(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.contactId
        );
        Alert.success(`Email template deleted successfully`);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }

  search(e) {
    let teamList = this.state.listData;
    teamList.map((e) => (e.selected = false));
    this.setState({
      SelectedList: [],
      MasterChecked: false,
      listData: teamList,
      searchValue: e.target.value,
      currentPage: 1
    });
    let value;
    value = e.target.value;
    const reg = /^[a-zA-Z0-9_ @]*$/;
    if (reg.test(value)) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.setState({ search: value });
        this.getEmailProvider(1, this.state.perPageCount, value);
      }, 500);
    }
  }

  componentDidMount() {
    this.getEmailProvider(
      this.state.currentPage,
      this.state.perPageCount,
      this.state.search
    );
  }

  // handleModalShowHide() {
  //   this.setState({ showHide: !this.state.showHide });
  // }

  getEmailProvider(page = 1, perPage = "", searchText = "") {
    var that = this;
    this.setState({ loading: true });
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `setting/email-templete?limit=${perPage}&search=${searchText}&page_no=${page}&orderBy=create_at&order=DESC`,
      (data) => {
        if (data.data.length === 0 && page > 1) {
          return this.getEmailProvider(--page, perPage, searchText);
        }
        this.setState({ loading: false });
        if (data && data.data) {
          const newListData = data.data.map((item) => {
            return {
              ...item,
              selected: false,
            };
          });
          that.setState({
            listData: newListData,
            total: data.count || 0,
            SelectedList: [],
            ary: [],
            MasterChecked: false,
          });
        } else {
          that.setState({ listData: [] });
        }
      },
      (error, data) => {
        this.setState({ loading: false });
        // if (data) {
        //   Alert.success(`${data.message}`);
        // } else {
        //   Alert.error(`${error}`);
        // }
      }
    );
  }

  onPaginationChange(page) {
    this.setState({ currentPage: page });
    this.getEmailProvider(page, "", this.state.search);
  }

  onPerPageChooser(perPage) {
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getEmailProvider(1, perPage, this.state.search);
  }

  closeModalShow() {
    this.setState({ show: false });
  }

  closeModal(isUpdated) {
    this.setState({ showHide: false });
    if (isUpdated === true) {
      this.getEmailProvider(this.state.currentPage, this.state.perPageCount, this.state.search);
    }
  }
  openModal(data) {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({ showHide: true, editData: null });
    }
  }

  remove(array, key, value) {
    const index = array.findIndex((obj) => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }

  deleteSmsTemplete(tEmailProvider) {
    var that = this;
    this.mAPI.sendPostAPI(
      `setting/sms-templete/${tEmailProvider._id}`,
      undefined,
      (data) => {
        let tD = that.state.listData;
        tD = that.remove(tD, "_id", tEmailProvider._id);
        that.setState({ listData: tD });
        that.getEmailProvider(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.contactId
        );
        Alert.success(data.message);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data.message}`);
      },
      "private",
      {},
      "DELETE"
    );
  }

  onChange() {}

  onSingleChange(e, company) {}

  editEmailProvider(tEmailProvider) {
    return (
      <ButtonCommonTheme
        type="edit"
        editOnClick={() => this.openModal(tEmailProvider)}
      />
    );
  }

  getIDDetails(tEmailProvider) {
    var that = this;
    this.setState({ loading: true });
    this.mAPI.sendGetAPI(
      `setting/sms-provider/${tEmailProvider}`,
      (data) => {
        this.setState({ loading: false });
      },
      (error, data) => {
        // if (data) {
        //   Alert.success(`${data.message}`);
        // } else {
        //   Alert.error(`${error}`);
        // }
      }
    );
  }

  deleteEProvider(tEmailProvider) {
    var that = this;
    this.mAPI.sendPostAPI(
      `setting/email-templete/${tEmailProvider._id}`,
      undefined,
      (data) => {
        let tD = that.state.listData;
        tD = that.remove(tD, "_id", tEmailProvider._id);
        that.setState({ listData: tD });
        that.getEmailProvider(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.search
        );
        Alert.success(data.message);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data.message}`);
      },
      "private",
      {},
      "DELETE"
    );
  }
  renderActions(tEmailProvider, index) {
    const { __ } = this.context;
    return (
      <ActionButtons>
        {this.editEmailProvider(tEmailProvider)}
        <CustomDropdown
          index={index}
          totalLength={this.state.listData.length || 0}
        >
          <MenuItem style={{ marginLeft: "0px" }}>
            <a
              onClick={(e) =>
                confirm().then((e) => {
                  this.deleteEProvider(tEmailProvider, e);
                })
              }
            >
              {"Delete"}
            </a>
          </MenuItem>
        </CustomDropdown>
      </ActionButtons>
    );
  }

  importContact(file) {
    let formData = new FormData();
    formData.append("file", file);
    return formData;
  }

  renderActionBar() {
    let _this = this;
    const ImportTrigger = ({ onClick }) => {
      return <ButtonCommonTheme type="add" addOnClick={onClick} />;
    };
    return (
      <span style={{ display: "flex", whiteSpace: "nowrap" }}>
        <ModalTrigger
          title="Email Template"
          trigger={<ImportTrigger />}
          size="md"
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          openModalShow={this.openModal}
          dialogClassName={this.state.modalType}
        >
          <EmailtempleteAddEdit
            update={() => this.setState({ currentPage: 1 })}
            size="small"
            isEdit={false}
            editData={this.state.editData}
            closeModal={this.closeModal}
            modalType={this.state.modalType}
            clearSearchField={this.clearSearchField}
          />
        </ModalTrigger>
      </span>
    );
  }
  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __("Settings"), link: "/settings" },
      { title: __("Email Template"), link: "/settings/email-template" },
    ];

    const mainContent = (
      <DataWrapperClass className="tableFixHeadSecondary">
        {/* <OverflowClass style={{overflow:'auto'}}> */}
        <Table whiteSpace="nowrap" bordered hover>
          <thead>
            <tr>
              <th onClick={this.onClick}>
                <FormControl
                  componentClass="checkbox"
                  checked={this.state.MasterChecked}
                  onChange={(e) => this.onMasterCheck(e)}
                />
              </th>
              <th>{__("NAME")}</th>
              {/* <th>{__('URL')}</th> */}
              {/* <th>{__('ELEMENTS')}</th> */}
              <th>{__("Actions")}</th>
            </tr>
          </thead>
          <tbody id="SmsTemplete">
            {this.state.listData &&
              this.state.listData.map((tEmailProvider, index) => (
                <tr key={tEmailProvider._id}>
                  <td onClick={this.onClick}>
                    <FormControl
                      componentClass="checkbox"
                      checked={tEmailProvider.selected}
                      onChange={(e) => this.onItemCheck(e, tEmailProvider)}
                    />
                  </td>
                  <td className="">{tEmailProvider.name}</td>
                  {/* <td>{tEmailProvider.url}</td> */}
                  {/* <td>
                            {tSIPExtension.elements}
                          </td> */}
                  <td>{this.renderActions(tEmailProvider, index)}</td>
                </tr>
              ))}
          </tbody>
        </Table>
        {/* </OverflowClass> */}
      </DataWrapperClass>
    );

    return (
      <div className="heightClass">
        <DataWrapperClass>
          <Wrapper
            header={<Wrapper.Header breadcrumb={breadcrumb} />}
            heading={
              // <ControlLabel>{this.moduleName}</ControlLabel>
              <CenterFlexRow className="header-label">
                <Link className="btn-back" to={`/settings`}>
                  <BackButton>
                    <Icon icon="angle-left" size={20} />
                  </BackButton>
                </Link>
                <ControlLabel>{this.moduleName}</ControlLabel>
              </CenterFlexRow>
            }
            actionBar={
              <Wrapper.ActionBar
                left={
                  <div style={{ display: "flex" }}>
                    <SeachForm className="mr-5">
                      <FormControl
                        type="text"
                        placeholder={"Search Here"}
                        onChange={(e) => this.search(e)}
                        value={this.state.searchValue}
                        autoFocus={false}
                      />
                      <span className="material-symbols-outlined">search</span>
                    </SeachForm>
                    {this.state.SelectedList.length > 0 && (
                      <ButtonCommonTheme
                        type="deleteAll"
                        checkboxDeleteOnClick={(e) =>
                          confirm().then((e) => {
                            this.deleteAllData(e);
                          })
                        }
                      />
                    )}
                  </div>
                }
                right={this.renderActionBar()}
              />
            }
            footer={
              <ReportPagination
                count={this.state.total}
                onPaginationChange={this.onPaginationChange}
                onPerPageChooser={this.onPerPageChooser}
                currentPage={this.state.currentPage}
                perPage={this.state.perPageCount}
              />
            }
            leftSidebar={<SettingDropdownMenu />}
            showLeftSideBar={true}
            content={
              <div>
                <DataWithLoader
                  data={mainContent}
                  loading={this.state.loading}
                  size={this.state.listData.length}
                  count={this.state.listData.length}
                  emptyText={`Sorry..! No ${this.moduleName} Found`}
                  emptyImage="/images/NoTemplate.svg"
                />
              </div>
            }
          />
        </DataWrapperClass>
      </div>
    );
  }
}

EmailTemplete.contextTypes = {
  __: PropTypes.func,
};

export default EmailTemplete;



// WEBPACK FOOTER //
// src/modules/screens/settings/EmailTemplete/components/EmailTemplete.js